<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="100px"
  >
    <el-form-item
        label="机器人名称"
        prop="name"
    >
      <el-input
          placeholder="请输入"
          v-model="form.name"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="描述"
        prop="desc"
    >
      <el-input
          placeholder="请输入"
          v-model="form.desc"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="token"
        prop="token"
    >
      <el-input
          type="password"
          maxlength="100"
          show-password
          autocomplete="new-password"
          :placeholder="editing ? '留空则保留原 Token' : '请输入'"
          v-model="form.token"
    ></el-input>
    </el-form-item>
    <el-form-item
        label="功能定位"
        prop="botRole"
    >
      <el-checkbox
          v-model="collectChecked"
      >采集</el-checkbox>
      <el-checkbox
          v-model="pushChecked"
      >推送</el-checkbox>
    </el-form-item>
    <el-form-item
        label="状态"
        prop="pushConfig"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
          v-model="form.status"
          :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  name: '',
  desc: '',
  token: '',
  status: 1,
  botRole: 3,
}
export default {
  name: "telegramForm",
  components:{
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        desc:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        token:[
          { validator: this.validateToken, trigger: 'blur' },
        ],
        botRole:[
          { validator: this.validateBotRole, trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    collectChecked: {
      get() { return (this.form.botRole & 1) === 1 },
      set(val) {
        // 位掩码：清除采集位后按勾选状态置位
        this.form.botRole = ((this.form.botRole || 0) & ~1) | (val ? 1 : 0);
      },
    },
    pushChecked: {
      get() { return (this.form.botRole & 2) === 2 },
      set(val) {
        this.form.botRole = ((this.form.botRole || 0) & ~2) | (val ? 2 : 0);
      },
    },
  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal){
        if(newVal){
            this.form = {
                ...originForm,
                ...newVal,
                token: this.editing ? '' : (newVal.token || ''),
            }
        }
      },
      deep:true,
    },
  },
  created(){
      if(this.formData.id){
          this.form = {
              ...originForm,
              ...this.formData,
              token: this.editing ? '' : (this.formData.token || ''),
          }
      }
  },
  methods:{
    validateToken(rule, value, callback){
      const token = String(value || '');
      if(!token.trim()){
        callback(this.editing ? undefined : new Error('请输入机器人Token'));
      }else if(token.length > 100){
        callback(new Error('机器人Token不能超过100个字符'));
      }else{
        callback();
      }
    },
    // required 不会拦截 0，故用 validator 显式校验身份合法（1/2/3）
    validateBotRole(rule, value, callback){
      if(value === 1 || value === 2 || value === 3){
        callback();
      }else{
        callback(new Error('请选择机器人身份'));
      }
    },
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
